export const CHART_TYPES = {
  line: {
    id: 'line',
    value: 'line'
  },
  pie: {
    id: 'url',
    value: 'url'
  },
  bar: {
    id: 'bar',
    value: 'bar'
  },
  doughnut: {
    id: 'doughnut',
    value: 'doughnut'
  },
  bubble: {
    id: 'bubble',
    value: 'bubble'
  },
  scatter: {
    id: 'scatter',
    value: 'scatter'
  }
};
